"use strict";
/**
 * CrudeFileUploadComponent
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ButtonComponent_1 = __importDefault(require("../../../../shared/components/FormComponents/ButtonComponent"));
var UploadFile_1 = __importDefault(require("@mui/icons-material/UploadFile"));
var schemaTypes_1 = require("../../../../shared/types/schemaTypes");
var commonTypes_1 = require("../../../../shared/types/commonTypes");
var ImageCropperComponent_1 = __importDefault(require("../../../../shared/components/CrudeComponents/ImageCropperComponent"));
var material_1 = require("@mui/material");
var crude_selector_1 = require("../../../../store/crude/crude.selector");
var react_redux_1 = require("react-redux");
var DialogComponent_1 = __importDefault(require("../../../../shared/components/MessageComponents/DialogComponent"));
var CrudeFileUploadComponent = function (props) {
    var _a, _b;
    var t = react_i18next_1.useTranslation().t;
    var _c = react_1.default.useState(), file = _c[0], setFile = _c[1];
    var _d = react_1.default.useState(false), openImageCropper = _d[0], setOpenImageCropper = _d[1];
    var _e = react_1.default.useState(false), pendingUpload = _e[0], setPendingUpload = _e[1];
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var useImageCropper = crudeLicense.imageCropper.available ? (appLayout.useImageCropper || false) : false;
    var disabled = props.disabled ? props.disabled : false;
    var allowedExtension = (_a = props.schema.fileSpecification) === null || _a === void 0 ? void 0 : _a.allowedFileExtensions;
    var aspectRatio = ((_b = props.schema.fileSpecification) === null || _b === void 0 ? void 0 : _b.aspectRatio) || undefined;
    var fileMainType = props.schema.columnSubType ? props.schema.columnSubType : schemaTypes_1.ColumnSubType.Document;
    react_1.useEffect(function () {
        setPendingUpload(props.fetchingUpload);
    }, [props.fetchingUpload]);
    var acceptExtensions = '';
    if (allowedExtension) {
        allowedExtension.map(function (ext) {
            acceptExtensions = acceptExtensions + ", ." + ext;
        });
    }
    else {
        var enumValues = void 0;
        switch (fileMainType) {
            case schemaTypes_1.ColumnSubType.Image:
                enumValues = Object.values(commonTypes_1.ImageType);
                break;
            case schemaTypes_1.ColumnSubType.Video:
                enumValues = Object.values(commonTypes_1.VideoType);
                break;
            case schemaTypes_1.ColumnSubType.Text:
                enumValues = Object.values(commonTypes_1.TextType);
                break;
            default:
                enumValues = Object.values(commonTypes_1.DocumentType);
                break;
        }
        // @ts-ignore
        enumValues && enumValues.map(function (enumExt) {
            acceptExtensions = acceptExtensions + ", ." + enumExt;
        });
    }
    react_1.useEffect(function () {
        var fileType = file && file.type;
        var cropperTypes = ['ico', 'png', 'jpg', 'bmp', 'gif', 'jpeg', 'svg', 'webp'];
        if (fileMainType === schemaTypes_1.ColumnSubType.Image && useImageCropper && cropperTypes.findIndex(function (type) { return "image/" + type === fileType; }) !== -1) {
            setOpenImageCropper(true);
        }
        else {
            file && props.onUpload(file);
        }
    }, [file]);
    var onChange = function (e) {
        e.preventDefault();
        var files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        }
        else if (e.target) {
            files = e.target.files;
        }
        setFile(files[0]);
        if (fileMainType === schemaTypes_1.ColumnSubType.Image) {
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                setImage(reader_1.result);
            };
            reader_1.readAsDataURL(files[0]);
        }
    };
    var hiddenFileInput = react_1.default.useRef(null);
    var handleClick = function () {
        // @ts-ignore
        !pendingUpload && hiddenFileInput.current.click();
    };
    var _f = react_1.useState(), image = _f[0], setImage = _f[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        crudeLicense.fileUpload.available &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ButtonComponent_1.default, { styles: { width: props.fullWidth ? '100%' : '300px', cursor: pendingUpload ? 'default' : 'pointer' }, disabled: disabled, startIcon: pendingUpload ? react_1.default.createElement(material_1.CircularProgress, { size: '20px' }) : react_1.default.createElement(UploadFile_1.default, null), color: 'primary', text: props.label + " " + t('crude:upload') || t('crude:uploadNewFile'), onClick: handleClick }),
                react_1.default.createElement("input", { type: 'file', ref: hiddenFileInput, onInput: onChange, style: { display: 'none' }, accept: acceptExtensions || '*' })),
        image &&
            react_1.default.createElement(DialogComponent_1.default, { open: openImageCropper, request: true, onClose: function () { return setOpenImageCropper(false); }, cancelLabel: t('crude:close'), confirmLabel: null, autoClose: false, onCancel: function () { return setOpenImageCropper(false); }, content: react_1.default.createElement(material_1.Box, { style: { padding: '20px' } },
                    react_1.default.createElement("div", { className: 'previewImage' }),
                    react_1.default.createElement(ImageCropperComponent_1.default, { image: image, previewContainer: 'previewImage', useOrigin: function () {
                            setPendingUpload(true);
                            file && props.onUpload(file);
                            setOpenImageCropper(false);
                        }, changeImage: function (image) {
                            if (file) {
                                setPendingUpload(true);
                                var arr = image.split(',');
                                var mimeArray = arr[0].match(/:(.*?);/);
                                var mimeType = mimeArray ? mimeArray[1] : 'image/png';
                                var bstr = atob(arr[1]);
                                var n = bstr.length;
                                var u8arr = new Uint8Array(n);
                                while (n--) {
                                    u8arr[n] = bstr.charCodeAt(n);
                                }
                                var newFile = new File([u8arr], file.name, { type: mimeType });
                                props.onUpload(newFile);
                                setOpenImageCropper(false);
                            }
                        } })) })));
};
exports.default = CrudeFileUploadComponent;
